import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API } from 'data/30pay.api';
import { post } from 'scripts';
import SiPayPanelInitialLoading from '30pay/initialLoading/initialLoading.index';
import { ThankYouPage } from '../../thankYou.index';
import { PATH } from 'data/30pay.path';

export const BuyPaymentThankYouPage: FC = () => {
    const navigate = useNavigate();
    const { trackingCode } = useParams();
    const [status, setStatus] = useState<'loading' | 'success' | 'failed'>('loading');
    const [data, setData] = useState<{ amount: string; fee?: string }>();

    useEffect(() => {
        if (!trackingCode) {
            setStatus('failed');
            return;
        }

        post<{ amount: string; fee?: string }>(API.orderTransaction.verifyBuy, {
            orderTransactionTrackingCode: trackingCode,
        })
            .then((res) => {
                setData(res.value.value);
                if (res.status === 200) setStatus('success');
                else setStatus('failed');
            })
            .catch(() => setStatus('failed'));
    }, [trackingCode]);

    if (status === 'loading') {
        return <SiPayPanelInitialLoading />;
    }

    return (
        <div className="max-w-[464px] m-auto w-full p-6">
            <ThankYouPage
                isSuccess={status === 'success'}
                amount={data?.amount}
                fee={data?.fee}
                trackingCode={trackingCode}
                onClose={() => navigate(PATH.dashboard)}
                onConfirm={() => navigate(PATH.reports)}
                hasAlert
            />
        </div>
    );
};
